import React from "react";
import AnimatedSvgThing from "../../animatedSvgBits/AnimatedSvgThing";

export default function Tape({ progress, timings, isTransparent }) {
  const maxTapeY = -0.5;
  const minTapeY = -28;
  const range = maxTapeY - minTapeY;
  const tapeInPathY = maxTapeY - range * progress;
  const tapeOutPathY = minTapeY + range * progress;

  return (
    <g transform={`translate(40, 95)`}>
      <AnimatedSvgThing
        className={`tapeComponent ${isTransparent && "transparent"}`}
        type="path"
        timings={timings}
        progress={progress}
        fill="none"
        stroke="#3f2b26"
        // stroke="green"
        strokeLinejoin="round"
        strokeWidth="2"
        d={`M0 ${tapeInPathY} 
        L30 23, 
        30 35, 
        0 39, 
        0 57, 
        60 65,
        90 65, 
        150 57, 
        150 39, 
        122 35, 
        122 23, 
        147 ${tapeOutPathY}`}
      />
    </g>
  );
}
